"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToAlignment = exports.mapToFit = void 0;
const mapToFit = (fit, canvas) => {
    if (fit === 'contain') {
        return canvas.Fit.contain;
    }
    if (fit === 'cover') {
        return canvas.Fit.cover;
    }
    if (fit === 'fill') {
        return canvas.Fit.fill;
    }
    if (fit === 'fit-height') {
        return canvas.Fit.fitHeight;
    }
    if (fit === 'fit-width') {
        return canvas.Fit.fitWidth;
    }
    if (fit === 'none') {
        return canvas.Fit.none;
    }
    if (fit === 'scale-down') {
        return canvas.Fit.scaleDown;
    }
    throw new Error('Invalid fit: ' + fit);
};
exports.mapToFit = mapToFit;
const mapToAlignment = (alignment, factory) => {
    if (alignment === 'center') {
        return factory.center;
    }
    if (alignment === 'bottom-center') {
        return factory.bottomCenter;
    }
    if (alignment === 'bottom-left') {
        return factory.bottomLeft;
    }
    if (alignment === 'bottom-right') {
        return factory.bottomRight;
    }
    if (alignment === 'center-left') {
        return factory.centerLeft;
    }
    if (alignment === 'center-right') {
        return factory.centerRight;
    }
    if (alignment === 'top-center') {
        return factory.topCenter;
    }
    if (alignment === 'top-left') {
        return factory.topLeft;
    }
    if (alignment === 'top-right') {
        return factory.topRight;
    }
    throw new Error('Invalid alignment: ' + alignment);
};
exports.mapToAlignment = mapToAlignment;
